export default "__VITE_ASSET__ngG7p2Bx__"